export const url = process.env.REACT_APP_API_URL || "http://localhost:5000";
// export const url = "https://api.arconest.cloud";
